export const IsSuperUser = (user) => user.userType === 0;
export const IsPortalUser = user => user.userType === 2;

const parseUserAccess = (user, model) => {
    const accessItem = user.accessList.filter(ac => ac.startsWith(`${model}:`));
    if(accessItem.length > 0) {
        const privileges = accessItem[0].split(':')[1].split(',');
        return privileges;
    }
    return null;
}


export const HasReadAccess = (user, model) => {
     const privileges = parseUserAccess(user, model);
     if (privileges){
         return privileges[0] === '1'
     }
     
     return false;
}

export const HasCreateAccess = (user, model) => {
    const privileges = parseUserAccess(user, model);
    if (privileges){
        return privileges[1] === '1'
    }

    return false;
}

export const HasWriteAccess = (user, model) => {
    const privileges = parseUserAccess(user, model);
    if (privileges){
        return privileges[2] === '1'
    }

    return false;
}

export const HasDeleteAccess = (user, model) => {
    const privileges = parseUserAccess(user, model);
    if (privileges){
        return privileges[3] === '1'
    }

    return false;
}